var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"loading-modal","visible":_vm.isLoading,"centered":"","hide-footer":"","title":"Processando Aguarde..."}},[_c('div',{staticClass:"text-center"},[_c('img',{attrs:{"src":require("@/assets/aguarde_2.gif"),"alt":"Loading"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }